import { NgModule } from '@angular/core';
import { PersonalizationCoreModule } from '@spartacus/tracking/personalization/core';

@NgModule({
  imports: [PersonalizationCoreModule],
})
export class PersonalizationModule {}
